import GenericTabComponent from "../../components/GenericTabComponent";
import About from "./Tabs/About";

export default function ESports2026() {
  const content = [
    { label: "About", component: <About /> },
  ];
  const pagetitle = "Bihar State Open eSports Championship Begins",
    desktopBanner = "https://biharsports.org/img/esports2026-banner.png",
    mobileBanner = "https://biharsports.org/img/esports2026-mobile.png";
  return (
    <>
      <GenericTabComponent
        content={content}
        desktopBanner={desktopBanner}
        mobileBanner={mobileBanner}
        pageTitle={pagetitle}
      />
    </>
  );
}
